import React from 'react';
import { Tag, seg } from '../tags/Tag';
import type { IconCellProps } from './types';

/**
 * IconCell - Renders an array of inline icon buttons
 * 
 * Features:
 * - Multiple icon buttons displayed inline (all visible)
 * - Spacing between buttons
 * - Individual click handlers per button
 * - Disabled state support (static or dynamic based on row)
 * 
 * Different from ActionCell which shows one overflow menu with dropdown
 */
export const IconCell: React.FC<IconCellProps> = ({ value, config, row }) => {
  if (!config?.buttons || config.buttons.length === 0) {
    return <span className="table-cell-text">—</span>;
  }

  const rowData = row || {};

  return (
    <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
      {config.buttons.map((button) => {
        const Icon = button.icon;
        const isDisabled = typeof button.disabled === 'function' 
          ? button.disabled(rowData) 
          : button.disabled;
        const ariaLabel = typeof button.ariaLabel === 'function'
          ? button.ariaLabel(rowData)
          : button.ariaLabel;
        const title = typeof button.title === 'function'
          ? button.title(rowData)
          : button.title;
          
        return (
          <Tag
            key={button.id}
            template="action-sm"
            segments={[seg.icon(Icon, { size: 16 })]}
            title={title || ariaLabel}
            onClick={() => button.onClick(rowData)}
            disabled={isDisabled}
          />
        );
      })}
    </div>
  );
};




